/**
 * Checkbox component
 */

import React, { forwardRef } from 'react';

/**
 * Checkbox component
 * @param {Object} props - Component props
 * @param {boolean} props.checked - Whether checkbox is checked
 * @param {Function} props.onChange - Change handler
 * @param {boolean} props.disabled - Whether checkbox is disabled
 * @param {string} props.label - Checkbox label
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.rest - Other input props
 */
const Checkbox = forwardRef(({
  checked = false,
  onChange,
  disabled = false,
  label,
  className = '',
  ...rest
}, ref) => {
  const baseClasses = 'h-4 w-4 rounded border-gray-300 dark:border-gray-600 text-customOrange focus:ring-customOrange focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed';
  
  return (
    <div className={`flex items-center ${className}`}>
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={baseClasses}
        {...rest}
      />
      {label && (
        <label
          className={`ml-2 text-sm text-gray-700 dark:text-[#c9d1d9] ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
          onClick={disabled ? undefined : () => onChange({ target: { checked: !checked } })}
        >
          {label}
        </label>
      )}
    </div>
  );
});

Checkbox.displayName = 'Checkbox';

export default Checkbox;
